import React, { useState } from 'react';
import Styles from './mobile-modal.module.scss';
import SiriusModal from '@lingxi-common-component/sirius-ui/SiriusModal';
import Input from '@lingxi-common-component/sirius-ui/Input';
import Button from '@lingxi-common-component/sirius-ui/Button';
import { apis, apiHolder as api, getIn18Text } from 'api';
const loginApi = api.api.requireLogicalApi(apis.loginApiImpl);
const MobileUnBlockingModal = props => {
    const { mobile, visible, onClose, onSuccess, onFail, onCancel } = props;
    const [mobileCode, setMobileCode] = useState('');
    const resendCodeWaitSpan = 60;
    const [time, setTime] = useState(resendCodeWaitSpan);
    const [errorMsg, setErrorMsg] = useState('');
    function startCountDown() {
        setTime(prev => {
            setTimeout(() => {
                if (prev > 0) {
                    startCountDown();
                }
                else {
                    setTime(resendCodeWaitSpan);
                }
            }, 1000);
            return prev > 0 ? prev - 1 : 0;
        });
    }
    const onGetMobileCode = () => {
        if (time < resendCodeWaitSpan) {
            return;
        }
        setErrorMsg('');
        loginApi.sendSelfUnBlockingCode().then(res => {
            if (res.success) {
                startCountDown();
            }
            else {
                setErrorMsg(res.errMsg);
            }
        });
    };
    const [isProcessing, setIsProcessing] = useState(false);
    const onSelefUnBlocking = () => {
        if (!mobileCode) {
            setErrorMsg(getIn18Text('QINGSHURUYANZHENG'));
            return;
        }
        setErrorMsg('');
        setIsProcessing(true);
        loginApi
            .selfUnBlockingWithCode(mobileCode)
            .then(res => {
            if (res.success) {
                onSuccess && onSuccess();
            }
            else {
                onFail && onFail(res.errMsg || '');
            }
        })
            .finally(() => {
            setIsProcessing(false);
        });
    };
    if (!visible) {
        return null;
    }
    return (React.createElement(SiriusModal, { width: 640, onCancel: () => {
            onClose && onClose();
        }, visible: visible, footer: null, maskClosable: false },
        React.createElement("div", { className: Styles.mainWrapper },
            React.createElement("div", { className: Styles.title }, getIn18Text('ACCOUNT_SPAM_TITLE')),
            React.createElement("div", { className: Styles.descWrapper },
                React.createElement("p", null, getIn18Text('SPAM_MOBILE_DESC')),
                React.createElement("p", null,
                    "1\u3001",
                    getIn18Text('SPAM_MOBILE_STEP1')),
                React.createElement("p", null,
                    "2\u3001",
                    getIn18Text('SPAM_MOBILE_STEP2')),
                React.createElement("p", null,
                    "3\u3001",
                    getIn18Text('SPAM_MOBILE_STEP3'))),
            React.createElement("div", { className: Styles.mobileCode },
                React.createElement("div", { className: Styles.line },
                    React.createElement("div", { className: Styles.label },
                        getIn18Text('SHOUJIHAO'),
                        "\uFF1A"),
                    React.createElement("div", { className: Styles.val }, mobile)),
                React.createElement("div", { className: Styles.line },
                    React.createElement("div", { className: Styles.label },
                        getIn18Text('SPAM_PHOPNE_CODE_LABEL'),
                        "\uFF1A"),
                    React.createElement("div", { className: Styles.input },
                        React.createElement(Input, { allowClear: true, placeholder: getIn18Text('QINGSHURUYANZHENG'), value: mobileCode, onChange: val => {
                                if (val && val.target) {
                                    setMobileCode(val.target.value);
                                }
                            } })),
                    React.createElement("div", { className: Styles.btn },
                        React.createElement(Button, { btnType: "primary", onClick: onGetMobileCode, disabled: time < resendCodeWaitSpan }, time < resendCodeWaitSpan ? `${time}s` : getIn18Text('HUOQUYANZHENGMA')))),
                React.createElement("div", { className: Styles.line },
                    React.createElement("div", { className: Styles.error }, errorMsg))),
            React.createElement("div", { className: Styles.btns },
                React.createElement("div", { style: { display: 'flex' } },
                    React.createElement(Button, { onClick: () => {
                            onCancel && onCancel();
                        } }, getIn18Text('QUXIAO')),
                    React.createElement(Button, { btnType: "primary", loading: isProcessing, onClick: () => {
                            onSelefUnBlocking();
                        } }, getIn18Text('QUEDING')))),
            React.createElement("div", { className: Styles.tips }, getIn18Text('SPAM_PHONE_CODE_TIP')))));
};
export default MobileUnBlockingModal;
